import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Axios instance for admin API calls — sends httpOnly cookies automatically */
export const adminApi = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
});

export { API };
